import React, {useState} from "react";
import { FormattedMessage } from "react-intl";
import {Button, Card, CardBody, CardHeader, Col, Nav, NavLink, Row} from "reactstrap";
import { useSaveButton } from "./FancyEntityEditor";

export function StepLayout({ children, saveOnLastStep }) {
    const [ active, setActive ] = useState(0);

    return <Row>
        <Col md="3">
            <Nav pills className="flex-column">
                { React.Children.map(children, (a, i) => <NavLink active={i === active} onClick={a => setActive(i)}>{i+1}. { a.props.title || <FormattedMessage id={a.props.translate} /> }</NavLink>) }
            </Nav>
        </Col>
        <Col>
            {
                React.Children.map(children, (a,i) => React.cloneElement(a, { saveOnLastStep, active: active === i, next: i !== children.length -1 ? (() => setActive(active + 1)) : null }))
            }
        </Col>
    </Row>;
}

export function Step(props) {
    const { title, translate, children, active, next, saveOnLastStep } = props;
    
    const saveBtn = useSaveButton();
    
    return <div style={{ display: active ? 'block' : 'none' }}>
        <Card>
            <CardHeader>
                <b>{ title || <FormattedMessage id={translate} /> }</b>
            </CardHeader>
            <hr style={{ margin: 0}}/>
            <CardBody >
                { children }
                <Row>
                    { next && <Col>
                        <Button type="button" color="primary" block onClick={next}>
                            Next
                            <i className="fas fa-arrow-circle-right ms-2" />
                        </Button>
                    </Col> }
                    { (!saveOnLastStep || !next) && <Col>
                        { saveBtn }
                    </Col> }
                </Row>
            </CardBody>
        </Card>
    </div>
}
